export default __webpack_public_path__ + "2398abe591512429a319423b9af4f18a.png";